<template>
    <div>
        <a-button class="top_btn" type="primary" v-has="'btn_add'"
                  @click="()=>{  visibleForm = true; titleForm='添加管理员' }"> 添加管理员
        </a-button>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id">
            <span slot="status" slot-scope="text, record">
         <a-switch   @click="onChange(record)" :disabled="!$_has('btn_status')||record.id==1"  :checked="text==1?true:false"/>
            </span>
            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>
                <span v-if=" record.id!=1">
                <a @click="(record)=>{visibleForm = true; titleForm='修改管理员'; editId=text.id ; }" v-has="'btn_edit'">编辑 <a-divider  type="vertical"/></a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm(record)"
                  @cancel="()=>{}"
          >
   <a v-has="'btn_delete'">删除</a>
  </a-popconfirm>
                    </span>
      </span>
        </a-table>
        <AdministratorForm :visible="visibleForm" :title="titleForm" :editId="editId"
                           @changVisible=" () => { this.visibleForm = false;this.editId=''; this.getList()}  "/>

    </div>

</template>

<script>
    import API from "./api";
    import AdministratorForm from "./components/administratorForm"
    import {changStatus, removeById} from "../../utils/utils"

    const columns = [
        {
            title: "用户名",
            dataIndex: "username",
            width: "15%",
            ellipsis: true,
            key: "username"
        },
        {
            title: "最后登录IP",
            dataIndex: "last_login_ip",
            ellipsis: true,
            key: "last_login_ip"
        },
        {
            title: "最后登录时间",
            dataIndex: "last_login_time",
            ellipsis: true,
            key: "last_login_time"
        },
        {
            title: "邮箱",
            dataIndex: "email",
            ellipsis: true,
            key: "email"
        },
        {
            title: "状态",
            key: "status",
            width: "10%",
            dataIndex: "status",
            scopedSlots: {customRender: "status"}
        },
        {
            title: "操作",
            key: "action",
            width: "200px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: 'AdministratorList',
        data() {
            return {
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                visibleForm: false,
                titleForm: "",
                loading: true,
                editId: null,
                jurisdictionId: null,
                visibleJurisdiction: false,
                data: [],
                columns,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/Administrator/AdministratorList"; //设置左侧导航2-2 active
        },
        components: {AdministratorForm},
        methods: {
            getList() {
                API.administrator.GET_ADMINISTRATOR().then(res => {
                    this.pagination.total = res.data.data.total
                    this.pagination.pageSize = res.data.data.per_page
                    this.pagination.current = res.data.data.current_page
                    this.data = res.data.data.data
                    this.loading = false
                })
            },

            onChange(row) {
                let Json = {id: row.id, status: row.status == 0 ? 1 : 0}
                changStatus(API.administrator.CHANG_STATUS_ADMINISTRATOR, [Json]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })

            },
            confirm(row) {
                removeById(API.administrator.GET_EDIT_ADMINISTRATOR, [row.id]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
        },
        mounted() {
            this.getList()
        }

    }
</script>
